<template>
  <main class="py-0 px-0 text-center">
    <slot />
    <div class="mt-0 mx-auto text-center opacity-25 text-sm">
      <!-- [Default Layout] -->
    </div>
  </main>
</template>
